// extracted by mini-css-extract-plugin
export default {"pageContentLoader":"styles_pageContentLoader__-FtT6"};